(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function () {
            const headers = document.querySelectorAll('.accordion-header');

            headers.forEach(header => {
                header.addEventListener('click', function () {
                    // Toggle active state for the clicked header
                    header.classList.toggle('active');

                    // Get the corresponding content
                    const content = header.nextElementSibling;

                    // Close all other accordion items
                    headers.forEach(otherHeader => {
                        if (otherHeader !== header) {
                            otherHeader.classList.remove('active');
                            otherHeader.nextElementSibling.style.display = 'none';
                        }
                    });

                    // Toggle the clicked accordion content
                    if (content.style.display === 'block') {
                        content.style.display = 'none';
                    } else {
                        content.style.display = 'block';
                    }
                });
            });
        });
    
  } catch(e) { console.error(e); }
})();
})();
